<template>
  <div v-click-outside="onClickOutside" class="simple-personalization-menu" :style="{ position: 'relative', width: size === 'small' ? '120px' : '160px', display: 'block' }">
    <button
      type="button"
      :class="['flex items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-full', size === 'small' ? 'h-8' : 'h-10']"
      @click="toggleOpen"
      style="display: flex; align-items: center; justify-content: space-between;"
    >
      <span style="pointer-events: none; flex: 1; text-align: left;">Personalization</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-4 w-4 opacity-50"
        style="pointer-events: none; flex-shrink: 0; display: block; margin-left: auto;"
      >
        <path d="m6 9 6 6 6-6"></path>
      </svg>
    </button>
    <div
      v-if="open"
      class="personalization-dropdown-menu"
      style="position: absolute; top: 100%; left: 0; margin-top: 4px; z-index: 10000; background: white; border: 1px solid #e5e7eb; border-radius: 0.375rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); min-width: 160px;"
    >
      <div
        class="personalization-item"
        style="padding: 8px 12px; cursor: pointer; font-size: 14px; color: #333; border-bottom: 1px solid #f3f4f6;"
        @click="selectField('[first_name]', $event)"
      >
        First Name
      </div>
      <div
        class="personalization-item"
        style="padding: 8px 12px; cursor: pointer; font-size: 14px; color: #333; border-bottom: 1px solid #f3f4f6;"
        @click="selectField('[business_name]', $event)"
      >
        Business Name
      </div>
      <div
        class="personalization-item"
        style="padding: 8px 12px; cursor: pointer; font-size: 14px; color: #333;"
        @click="selectField('[review_link]', $event)"
      >
        Review Link
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimplePersonalizationMenu',
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['small', 'normal'].includes(value),
    },
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    toggleOpen(e) {
      if (e) e.stopPropagation()
      this.open = !this.open
    },
    onClickOutside() {
      this.open = false
    },
    selectField(field, e) {
      if (e) e.stopPropagation()
      this.$emit('selected', field)
      this.open = false
    },
  },
}
</script>

<style scoped>
.simple-personalization-menu .personalization-item:hover {
  background-color: #f9fafb;
}

.simple-personalization-menu button {
  border: none !important;
  border-width: 0 !important;
}
</style>

